import { LeftCircleFilled, RightCircleFilled } from "@ant-design/icons";
import { Carousel } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import './SwipingCarousal.less'

const SwipingCarousal = ({ children }: any) => {
  const breakpoints = useBreakpoint();

  const slidesToShow = () => {
    const screens = Object.entries(breakpoints).filter((screen) => !!screen[1]);
    const screen_size = screens[screens.length - 1]?.[0];
    switch (screen_size) {
      case "md":
        return 2;
      case "sm":
        return 1;
      case "xs":
        return 1;
      default:
        return 3;
    }
  };

  return (
    <Carousel
      swipeToSlide={true}
      slidesToShow={slidesToShow()}
      dots={false}
      infinite={true}
      arrows={true}
      prevArrow={<LeftCircleFilled />}
      nextArrow={<RightCircleFilled />}
      style={{
        marginBottom: '10px',
      }}
    >
      {children}
    </Carousel>
  );
};

export default SwipingCarousal;
